module.exports = __webpack_public_path__ + "static/img/govcard_white_01.cf5dd387.svg";